import { render } from "./UserContact.vue?vue&type=template&id=6ea8b3d2&scoped=true"
import script from "./UserContact.vue?vue&type=script&lang=js"
export * from "./UserContact.vue?vue&type=script&lang=js"

import "./UserContact.vue?vue&type=style&index=0&id=6ea8b3d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea8b3d2"]])

export default __exports__